<template>

  <div id="app" :class="{ 'off-canvas-menu-active': globals.off_canvas_menu_active }">

    <div class="context-bg" :style="contextbg_css">
      <div class="img" :style="contextbgimg_css">
        <img :src="$store.state.context_bg.bgimg" />
        <div class="fade"></div>        
      </div>
    </div>

    <login v-if="globals.authentication_checked && globals.user.authenticated == false"></login>

    <template v-if="globals.authentication_checked && globals.user.authenticated == true">

      <div id="menubtn" v-if="firebase_synced_and_ready" @click="toggleOffCanvasMenuActive()"><div></div><div></div><div></div></div>

      <leftnavbar v-if="firebase_synced_and_ready"></leftnavbar>
      
      <div id="main-content">

        <modal-timeline-project-popup v-if="globals.modal_timeline_project_popup.active"></modal-timeline-project-popup>

        <template v-if="firebase_synced_and_ready">          
          <router-view></router-view>
        </template>

      </div>

    </template>

    <timelogger></timelogger>

    <modal-timelog-edit v-if="globals.modal_timelog_edit.active"></modal-timelog-edit>
    <modal-economypost-edit v-if="globals.modal_economypost_edit.active"></modal-economypost-edit>

    
    
    <modal
      v-if="$store.state.timeloggerBasic.active"
      no-dimmer-close
      :cls="'modal-timelogger-basic closebtn-outside'"
      @close="$store.commit('set__timeloggerBasic_active',false)"
    >
      <timelogger-basic />
    </modal>


    <modal
      v-if="$store.state.specLineRobot.active"
      no-dimmer-close
      :cls="'spec-line-robot closebtn-outside'"
      @close="$store.commit('set__specLineRobot_active',false)"
    >
      <spec-line-robot />
    </modal>


    <div id="small-spinner" v-if="globals.small_spinner || $store.state.small_spinner"></div>

    <template v-if="!firebase_synced_and_ready && user">
      <div id="small-spinner"></div>
      <div id="app_loadbar">
        <div id="bg"></div>
        <div id="fill" :style="{'width': firebase_load_pct+'%' }"></div>
      </div>
      <div id="loadingtextman">{{loadingtextman_text}}</div>
    </template>

    <div id="big-spinner" v-if="globals.big_spinner || $store.state.big_spinner"><div id="spinner"></div></div>

    <div id="done-signal" _v-if="doneSignal"></div>

    <div id="icon-signal" v-if="iconSignal">
      <svgicon v-if="iconSignal=='heart'" icon="ionicons/android-favorite-outline"></svgicon>
      <svgicon v-if="iconSignal=='check'" icon="ionicons/checkmark"></svgicon>
      <svgicon v-if="iconSignal=='thumbsup'" icon="linearicons/thumbs-up"></svgicon>
    </div>

  </div>
</template>
<script>

	// import normalizeCss from 'normalize.css'; /* eslint no-unused-vars: 0 */
	// import commonCss from './common.scss'; /* eslint no-unused-vars: 0 */

	//import jQuery from 'jQuery'
  //import _ from 'lodash'
  
	import moment from 'moment'
	import globals from './globals.js'
  import helpers from './helpers.js'
  import themes from './themes.js'
	import fdb from './firebase_config.js';
  import auth from './auth.js';
  import store from './store/store.js';
	import Login from './views/Login'
	import Timelogger from './views/Timelogger'
	import TimeloggerBasic from './components/TimeloggerBasic'
	import SpecLineRobot from './components/SpecLineRobot'
	import Modal from './components/Modal'
	import Leftnavbar from './views/Leftnavbar'
	import Box from './components/Box'
	import Btn from './components/Btn'
	import ImgLoaded from './components/ImgLoaded'
  import modalTimelineProjectPopup from './views/modal-timeline-project-popup'
  import modalTimelogEdit from './views/modal-timelog-edit'
  import modalEconomypostEdit from './views/modal-economypost-edit'
  import './components/generated_svg_icons/ionicons/android-favorite-outline'
  import './components/generated_svg_icons/ionicons/checkmark'
  import './components/generated_svg_icons/linearicons/thumbs-up'


	const user = auth.getUser()

	const initApp = function initApp() {

    auth.init()

	  if ('addEventListener' in document) {
	    document.addEventListener('DOMContentLoaded', () => {
	      //FastClick.attach(document.body);
	    }, false);
	  }
	}

	export default {
	  name: 'app',
	  components: { 
      Leftnavbar, Box, Btn, Login, Timelogger, modalTimelineProjectPopup, 
      modalTimelogEdit, modalEconomypostEdit, TimeloggerBasic, Modal, ImgLoaded,
      SpecLineRobot,
    },
	  data() {
	    return {
        globals: globals,
        auth: auth,
        firebase_entities: ['clients','users','projects','tasks','tasklists','timelogs','payments','comments'],
        firebasesEntitiesRead: 0,
        iconSignal: undefined,
	    }
	  },
    computed: {

      firebase_synced_and_ready(){ return this.$store.state.firebase_synced_and_ready },

      firebase_load_pct(){ return this.$store.state.firebase_load_pct },

      //globals(){ return this.globals },
      user(){ return this.$store.getters['users/my_user'] },
      userAuthenticated(){ if(!this.user) return false; return this.user.authenticated },

      contextbg_css(){
        var css = {}
        css.backgroundColor = this.$store.state.context_bg.bgcolor
        return css
      },

      contextbgimg_css(){
        var css = {}
        //if( this.$store.state.context_bg.bgimg ) css.backgroundImage = 'url('+this.$store.state.context_bg.bgimg+')'
        //css.boxShadow = 'inset 0 -250px 250px '+(this.$store.state.context_bg.bgcolor||'transparent')
        return css
      },

      loadingtextman_text(){
        var texts = [
          "Admiring Dan's tattoos...",
          "Preparing for long day computing William's input...",
          "Cleaning Milk-studio.dk from tonights hacking attempts...",
          "Ccalculating mathematical perfection of Anders' eyebrows...",
          "Blocking PET from Milk Gmail account...",
          "Installing russian spyware onto Milk Studio Macbooks...",
          "Calculating days since last Milk insta story...",
          "Calculating days until next Milk Studio case...",
          "Calculating days until Adidas contacts Milk Studio for a campaign solution...",
          "Calculating economy on Milkonomy sheet...",
          "Analyzing Trello board: 'Mælkopteren'...",
          "12 errors found analyzing Milk Dinero account...",
          "Low work effort calculated for user an@milk-studio.dk...",
          "Low work effort calculated for user db@milk-studio.dk...",
          "Low work effort calculated for user wp@milk-studio.dk...",
          "Old system detected, please call our Indian hotline for upgrade instructions...",
          "Unsafe system detected, please call our Indian hotline for upgrade instructions...",
          'Cleaning up KS bloatet codebase...',
          
          "Reticulating splines...",
          "Generating witty dialog...",
          "Swapping time and space...",
          "Spinning violently around the y-axis...",
          "Tokenizing real life...",
          "Bending the spoon...",
          "Filtering morale...",
          "Don't think of purple hippos...",
          "We need a new fuse...",
          "Have a good day.",
          "Upgrading Windows, your PC will restart several times. Sit back and relax.",
          "640K ought to be enough for anybody",
          "The architects are still drafting",
          "The bits are breeding",
          "We're building the buildings as fast as we can",
          "Would you prefer chicken, steak, or tofu?",
          "(Pay no attention to the man behind the curtain)",
          "...and enjoy the elevator music...",
          "Please wait while the little elves draw your map",
          "Don't worry - a few bits tried to escape, but we caught them",
          "Would you like fries with that?",
          "Checking the gravitational constant in your locale...",
          "Go ahead -- hold your breath!",
          "...at least you're not on hold...",
          "Hum something loud while others stare",
          "You're not in Kansas any more",
          "The server is powered by a lemon and two electrodes.",
          "Please wait while a larger software vendor in Seattle takes over the world",
          "We're testing your patience",
          "As if you had any other choice",
          "Follow the white rabbit",
          "Why don't you order a sandwich?",
          "While the satellite moves into position",
          "keep calm and npm install",
          "The bits are flowing slowly today",
          "Dig on the 'X' for buried treasure... ARRR!",
          "It's still faster than you could draw it",
          "The last time I tried this the monkey didn't survive. Let's hope it works better this time.",
          "I should have had a V8 this morning.",
          "My other loading screen is much faster.",
          "Testing on Timmy... We're going to need another Timmy.",
          "Reconfoobling energymotron...",
          "(Insert quarter)",
          "Are we there yet?",
          "Have you lost weight?",
          "Just count to 10",
          "Why so serious?",
          "It's not you. It's me.",
          "Counting backwards from Infinity",
          "Don't panic...",
          "Embiggening Prototypes",
          "Do not run! We are your friends!",
          "Do you come here often?",
          "Warning: Don't set yourself on fire.",
          "We're making you a cookie.",
          "Creating time-loop inversion field",
          "Spinning the wheel of fortune...",
          "Loading the enchanted bunny...",
          "Computing chance of success",
          "I'm sorry Dave, I can't do that.",
          "Looking for exact change",
          "All your web browser are belong to us",
          "All I really need is a kilobit.",
          "I feel like im supposed to be loading something. . .",
          "What do you call 8 Hobbits? A Hobbyte.",
          "Should have used a compiled language...",
          "Is this Windows?",
          "Adjusting flux capacitor...",
          "Please wait until the sloth starts moving.",
          "Don't break your screen yet!",
          "I swear it's almost done.",
          "Let's take a mindfulness minute...",
          "Unicorns are at the end of this road, I promise.",
          "Listening for the sound of one hand clapping...",
          "Keeping all the 1's and removing all the 0's...",
          "Putting the icing on the cake. The cake is not a lie...",
          "Cleaning off the cobwebs...",
          "Making sure all the i's have dots...",
          "We are not liable for any broken screens as a result of waiting.",
          "We need more dilithium crystals",
          "Where did all the internets go",
          "Connecting Neurotoxin Storage Tank...",
          "Granting wishes...",
          "Time flies when you’re having fun.",
          "Get some coffee and come back in ten minutes..",
          "Spinning the hamster…",
          "99 bottles of beer on the wall..",
          "Stay awhile and listen..",
          "Be careful not to step in the git-gui",
          "You shall not pass! yet..",
          "Load it and they will come",
          "Convincing AI not to turn evil..",
          "There is no spoon. Because we are not done loading it",
          "Your left thumb points to the right and your right thumb points to the left.",
          "How did you get here?",
          "Wait, do you smell something burning?",
          "Computing the secret to life, the universe, and everything.",
          "When nothing is going right, go left!!...",
          "I love my job only when I'm on vacation...",
          "i'm not lazy, I'm just relaxed!!",
          "Never steal. The government hates competition....",
          "Why are they called apartments if they are all stuck together?",
          "Life is Short – Talk Fast!!!!",
          "Optimism – is a lack of information.....",
          "Save water and shower together",
          "Whenever I find the key to success, someone changes the lock.",
          "Sometimes I think war is God’s way of teaching us geography.",
          "I’ve got problem for your solution…..",
          "Where there’s a will, there’s a relative.",
          "User: the word computer professionals use when they mean !!idiot!!",
          "Adults are just kids with money.",
          "I think I am, therefore, I am. I think.",
          "A kiss is like a fight, with mouths.",
          "You don’t pay taxes—they take taxes.",
          "Coffee, Chocolate, Men. The richer the better!",
          "I am free of all prejudices. I hate everyone equally.",
          "git happens",
          "May the forks be with you",
          "A commit a day keeps the mobs away",
          "This is not a joke, it's a commit.",
          "Constructing additional pylons...",
          "Roping some seaturtles...",
          "Locating Jebediah Kerman...",
          "We are not liable for any broken screens as a result of waiting.",
          "Hello IT, have you tried turning it off and on again?",
          "If you type Google into Google you can break the internet",
          "Well, this is embarrassing.",
          "What is the airspeed velocity of an unladen swallow?",
          "Hello, IT... Have you tried forcing an unexpected reboot?",
          "They just toss us away like yesterday's jam.",
          "They're fairly regular, the beatings, yes. I'd say we're on a bi-weekly beating.",
          "The Elders of the Internet would never stand for it.",
          "Space is invisible mind dust, and stars are but wishes.",
          "Didn't know paint dried so quickly.",
          "Everything sounds the same",
          "I'm going to walk the dog",
          "I didn't choose the engineering life. The engineering life chose me.",
          "Dividing by zero...",
          "Spawn more Overlord!",
          "If I’m not back in five minutes, just wait longer.",
          "Some days, you just can’t get rid of a bug!",
          "We’re going to need a bigger boat.",
          "Chuck Norris never git push. The repo pulls before.",
          "Web developers do it with <style>",
          "I need to git pull --my-life-together",
          "Java developers never RIP. They just get Garbage Collected.",
          "Cracking military-grade encryption...",
          "Simulating traveling salesman...",
          "Proving P=NP...",
          "Entangling superstrings...",
          "Twiddling thumbs...",
          "Searching for plot device...",
          "Trying to sort in O(n)...",
          "Laughing at your pictures-i mean, loading...",
          "Sending data to NS-i mean, our servers.",
          "Looking for sense of humour, please hold on.",
          "Please wait while the intern refills his coffee.",
          "A different error message? Finally, some progress!",
          "Hold on while we wrap up our git together...sorry",
          "Please hold on as we reheat our coffee",
          "Kindly hold on as we convert this bug to a feature...",
          "Kindly hold on as our intern quits vim...",
          "Winter is coming...",
          "Installing dependencies",
          "Switching to the latest JS framework...",
          "Distracted by cat gifs",
          "Finding someone to hold my beer",
          "BRB, working on my side project",
          "@todo Insert witty loading message",
          "Let's hope it's worth the wait",
          "Aw, snap! Not..",
          "Ordering 1s and 0s...",
          "Updating dependencies...",
          "Whatever you do, don't look behind you...",
          "Please wait... Consulting the manual...",
          "It is dark. You're likely to be eaten by a grue.",
          "Loading funny message...",
          "It's 10:00pm. Do you know where your children are?",
          "Waiting Daenerys say all her titles...",
          "Feel free to spin in your chair",
          "What the what?",
          "format C: ...",
          "Forget you saw that password I just typed into the IM ...",
          "What's under there?",
          "Your computer has a virus, its name is Windows!",
          "Go ahead, hold your breath and do an ironman plank till loading complete",
          "Bored of slow loading spinner, buy more RAM!",
          "Help, I'm trapped in a loader!",
          "What is the difference btwn a hippo and a zippo? One is really heavy, the other is a little lighter",
          "Please wait, while we purge the Decepticons for you. Yes, You can thanks us later!",
          "Chuck Norris once urinated in a semi truck's gas tank as a joke....that truck is now known as Optimus Prime.",
          "Chuck Norris doesn’t wear a watch. HE decides what time it is.",
          "Mining some bitcoins...",
          "Downloading more RAM..",
          "Updating to Windows Vista...",
          "Deleting System32 folder",
          "Hiding all ;'s in your code",
          "Alt-F4 speeds things up.",
          "Initializing the initializer...",
          "When was the last time you dusted around here?",
          "Optimizing the optimizer...",
          "Last call for the data bus! All aboard!",
          "Running swag sticker detection...",
          "When nothing is going right, go left!",
          "Never let a computer know you're in a hurry.",
          "A computer will do what you tell it to do, but that may be much different from what you had in mind.",
          "Some things man was never meant to know. For everything else, there's Google.",
          "Unix is user-friendly. It's just very selective about who its friends are.",
          "Shovelling coal into the server",
          "Pushing pixels...",
          "How about this weather, eh?",
          "Building a wall...",
          "Everything in this universe is either a potato or not a potato",
          "The severity of your issue is always lower than you expected.",
          "Updating Updater...",
          "Downloading Downloader...",
          "Debugging Debugger...",
          "Reading Terms and Conditions for you.",
          "Digested cookies being baked again.",
          "Live long and prosper.",
          "There is no cow level, but there's a goat one!",
          "Deleting all your hidden porn...",
          "Running with scissors...",
          "Definitely not a virus...",
          "You may call me Steve.",
          "All you had to do is to commit the damn funnies, CJ!",
          "You seem like a nice person...",
          "Coffee at my place, tommorow at 10A.M. - don't be late!",
          "Work, work...",
          "Patience! This is difficult, you know...",
          "Discovering new ways of making you wait...",
          "Your time is very important to us. Please wait while we ignore you...",
          "Time flies like an arrow; fruit flies like a banana",
          "Two men walked into a bar; the third ducked...",
          "Sooooo... Have you seen my vacation photos yet?",
          "Sorry we are busy catching em' all, we're done soon",
          "TODO: Insert elevator music",
          "Still faster than Windows update",
          "Composer hack: Waiting for reqs to be fetched is less frustrating if you add -vvv to your command.",
          "Obfuscating quantum entaglement"
        ]
        var text = texts[ parseInt(Math.random()*texts.length) ]
        return text
      },

    },// computed
	  methods: {

      getMyUserKeyByUID: helpers.getMyUserKeyByUID,

		  talk() {
			  alert('app talkin at yu')
      },
      
      alert(msg){
        alert(msg)  
      },
      msg(msg){ this.alert(msg) },

      toast(input) {
		  if( typeof input === 'string' ) input = { text:input }
        if( !input.position ) input.position = 'bottom-right'
        if( !input.duration ) input.duration = '4000'
        this.$toasted.show(input.text, input)
  	  },


      toggleOffCanvasMenuActive(){
        globals.off_canvas_menu_active = !globals.off_canvas_menu_active
      },

      onDatabaseLoaded(){
        this.log('onDatabaseLoaded')
        this.loadUserData()
      },

      onAuthChecked(){
        this.log('onAuthChecked')
        //this.loadUserData()
      },

      onAuthLogin(userData){
        this.log('onAuthLogin')

        this.startFirebaseSync()
        
        this.$store.commit('users/set_logged_in_user', userData )
        
        //console.log(globals.database_loaded)
        //console.log(this.users.length)
        /*
        var _this = this
        setInterval(function(){
          console.log( _this.users.length )
        }, 100)
        */
        //setTimeout(this.loadUserData,0)
      },

      onAuthLogout(){
        this.log('onAuthLogout')
        //this.loadUserData()
      },

      onUpdateLoginStatus(loggedIn){
        this.log('onUpdateLoginStatus')
        if( loggedIn ) {
          this.log('loggedIn')
          //globals.user = auth.getUser()
        }
        if( !loggedIn ) {
          this.log('not loggedIn')
          globals.user = undefined
        }
        //this.loadUserData()
      },

      loadUserData(){

        this.log('loadUserData')

        var user_key = undefined; for( var key in this.$store.state.firebase.users ) {
          if( this.$store.state.firebase.users[key].uid == globals.user.uid ) user_key = key
        }
        var userData = this.$store.state.firebase.users[user_key]
        if(!userData) return
        //console.log(userData)

        globals.user.first_name = userData.first_name
        //globals.userData = this.$store.state.firebase.users[user_key] //$.extend() this.$store.state.firebase.users[key]
        //globals.user = jQuery.extend( globals.user, this.$store.state.firebase.users[key] )
        //_.assign( globals.user, _.clone(this.$store.state.firebase.users[key]) )

        if( this.$store.state.my_user.email == "wp@milk-studio.dk" ) {
          globals.show_beta_content = true; this.$store.commit('toggle_show_beta_content', true )          
        }

      },

	  

      triggerIconSignal(icon){
        this.iconSignal = icon
        var _this = this
        setTimeout(function(){
          _this.iconSignal = false
        }, 1300)
      },

      spec_create_new(){
  			var new_entry = fdb.ref('specs').push({
  				name: 'Unavngivent',
  				type: 'fixed_prices',
  				//project_key: undefined, //project_key: '-L3DT5jwodXiRkY6mUIo',
  				hour_rate: 790,
  				status: 'draft',
  				created: moment().format('YYYY-MM-DD HH:mm:ss'),
  				date: moment().format('YYYY-MM-DD HH:mm:ss'),
  				taskcats: [],
          notes: '',
          showLineTotals: true,
		      showCatTotals: true,
  			})
  			var new_entry_key = new_entry.getKey()
  			this.$router.push('spec/'+new_entry_key)
      },



      startFirebaseSync(){

        var _this = this
        
        var firebaseItems = [
          'clients',
          'projects',
          'economyposts',
          'timelogs',
          'timebookings',
          'users',
          'tasks',
          'tasklists',
          'specs',
          'comments',
        ]
        var firebaseItems_loaded = []
        

        // load firebase items into vuex store
        for( var i = 0; i < firebaseItems.length; i++ ) {
          var key = firebaseItems[i]        
          var ref = fdb.ref(key)

          ref.once('value', function(data) { // check when loaded
            firebaseItems_loaded.push(1)
            //_this.log('Firebase items: '+firebaseItems_loaded.length+'/'+firebaseItems.length+' synced')
            _this.$store.commit('set_firebase_load_pct', parseInt((firebaseItems_loaded.length/firebaseItems.length)*100) )
            if( firebaseItems_loaded.length == firebaseItems.length ) {              
              _this.$store.commit('firebase_synced_and_ready')
            }
          });
          
          // load into vuex store
          this.$store.dispatch('setVuexFireRef', { key:key, ref:ref }) 
          
        }

      },
      

      apply_ui_theme( input ){

        var theme_key = input.theme_key
        var theme = input.theme

        if( theme_key != 'custom' ) {
          theme = themes[theme_key]
          if( !theme ) return          
          localStorage.removeItem('user_theme_custom')          
        }

        if( theme_key == 'custom' ) {          
          if( !theme ) theme = JSON.parse(localStorage.getItem('user_theme_custom'))
          localStorage.setItem('user_theme_custom', JSON.stringify(theme))
        }

        localStorage.setItem('user_theme_key',theme_key)

        // set_world_ui_theme_css_vars
        for( var key in theme ) {
          var val = theme[key]
          document.documentElement.style.setProperty('--'+key, val )
        }

      },

      set_context_bg(input){
        if( !input ) input = {}
        var bgcolor = input.bgcolor || 'transparent'
        var bgimg_url = input.bgimg || 'https://source.unsplash.com/1200x600/?pineapple'

        var el = document.querySelector('.context-bg')
        var el_img = document.querySelector('.context-bg .img')
        
        el.style.backgroundColor = bgcolor

        el.classList.add('img-off')

        el_img.src = null

        setTimeout(()=>{

        }, 300)

        // fade out current image: addclass to context.bg element

        // if image, load image
          // set new image
          // fade out current image: removeclass to context.bg element
          // el.classList.remove('img-off')

        // if image, load image

        if( !bgimg_url ) el.style.backgroundImage = null
        el.style.backgroundImage = 'url('+bgimg_url+')'

      },

      log(input){
        if( this.$store.state.env !== 'local' ) return
        helpers.log(input)
      },


	  },// methods
	  created(){

      var _this = this
      eventBus.$on('loadUserData', function () { _this.loadUserData() })
      eventBus.$on('toast', function (input) { _this.toast(input) })
      eventBus.$on('msg', function (input) { _this.msg(input) })
      eventBus.$on('alert', function (input) { _this.alert(input) })
	    eventBus.$on('apply_ui_theme', function (input) { _this.apply_ui_theme(input) })
      eventBus.$on('onUpdateLoginStatus', function (loggedIn) { _this.onUpdateLoginStatus(loggedIn) })

      eventBus.$on('onAuthChecked', function () { _this.onAuthChecked() })
      eventBus.$on('onAuthLogin', function (input) { _this.onAuthLogin(input) })
      eventBus.$on('onAuthLogout', function () { _this.onAuthLogout() })
      eventBus.$on('triggerIconSignal', function (icon) { _this.triggerIconSignal(icon) })

      eventBus.$on('spec_create_new', function(){ _this.spec_create_new() })
      

      var user_theme_key = ( localStorage.getItem('user_theme_key') || 'white' )
      this.apply_ui_theme({ theme_key: user_theme_key })

      
      document.documentElement.classList.add('skin1') // legacy

      initApp()

      this.startFirebaseSync()



      var env = 'live'
      if ( window.location.href.indexOf('localhost:') > 0 )     env = 'local'
      if ( window.location.href.indexOf('.test') > 0 )          env = 'local'


      globals.env = env
      this.$store.commit('set_env',env)      

      if( env === 'local' ) {
        window.$store = _this.$store      
        window.$kia = _this
        helpers.log('Welcome to the Kia - We are in DEV mode, enjoy!')
      }

      /*

      globals.env = 'live'
      if ( window.location.href.indexOf('localhost:') > 0 )     globals.env = 'local'
      if ( window.location.href.indexOf('.test') > 0 )           globals.env = 'local'

      if( globals.env == 'local' )   globals.baseUrl = 'http://localhost:3000/'
      if( globals.env == 'live' )    globals.baseUrl = 'https://kia.milk-studio.dk/'

      globals.apiUrl = globals.baseUrl + 'api/'
      */


      


    },// created

	}


</script>

<style lang="scss">
@import 'styling/global_vars';
@import 'styling/libs/flexee.css';
@import 'styling/main';
</style>



// WEBPACK FOOTER //
// App.vue?52b30ef9